import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Shield } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center">
        <div className="text-center">
          <div className="relative mb-4 inline-block">
            <Shield className="h-16 w-16 text-cyan-400 animate-pulse" />
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-green-400 rounded-full animate-ping"></div>
          </div>
          <h2 className="text-xl font-semibold text-white mb-2">CyberGuard Global</h2>
          <p className="text-gray-400">Verifying your credentials...</p>
          <div className="mt-4 flex items-center justify-center">
            <div className="w-8 h-1 bg-cyan-400 rounded-full animate-pulse mr-1"></div>
            <div className="w-8 h-1 bg-cyan-400 rounded-full animate-pulse delay-75 mr-1"></div>
            <div className="w-8 h-1 bg-cyan-400 rounded-full animate-pulse delay-150"></div>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to home with login prompt if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ showLogin: true }} />;
  }

  // Render protected content if authenticated
  return children;
};

export default ProtectedRoute;